import {Usage} from '../common/UsageSchema';
import {ScannedLicensePlate} from './ScannedLicensePlate';

export type ScanLicensePlateUseCaseResult = {
  result: ScannedLicensePlate;
  usage: Usage;
};
